module.exports = __webpack_public_path__ + "img/minus_btn.9d2ca158.png";